import { ROOT_PATH } from 'app/shared/consts';
import { Route, Routes } from 'react-router-dom';

import { DefaultRedirect } from 'app/components/router/default-redirect';
import { ErrorPage } from 'app/pages/error';
import React from 'react';
import { ContentPage } from 'app/pages/content';
import { AppContentWrapper } from 'app/components/app-content-wrapper';
import { AppRoot } from 'app/components/app-root';
import { Private } from 'app/components/router/components/private';
import { PageImpressionsObserver } from 'app/components/router/components/page-impressions-observer';

export const AppRouter: React.FC = () => (
  <AppContentWrapper>
    <Routes>
      <Route element={<PageImpressionsObserver />}>
        <Route path={ROOT_PATH} element={<Private><ContentPage /></Private>} />
        <Route path="/" element={<AppRoot />} />
        <Route path="/error" element={<ErrorPage />} />
        <Route element={<DefaultRedirect />} />
      </Route>
    </Routes>
  </AppContentWrapper>
  );
